import { Card, Row, Col } from "react-bootstrap";
import IconSvg from "../../../SharedComponents/IconSvg";
import { useDispatch, useSelector } from "react-redux";
import { RemoveFromProjectList } from "../Store";
import ScrollableCard from "../../../SharedComponents/ScrollableCard";
import { useTranslation } from "react-i18next";

const ProjectList = ({ isInModal }) => {
  const { t } = useTranslation();
  const projectList = useSelector((state) => state.projects.projectList);
  const dispatch = useDispatch();

  return (
    <Card className={"default-list with-shadow m-2 "}>
      <Card className={"header mb-0 d-none d-lg-block"}>
        <Row
          className={"justify-content-between ms-5 text-20 text-color-gray-light fw-medium me-4"}
          style={{ height: "50px" }}
        >
          <Col xs={3} className={"align-content-center"}>
            <Row>{t("projectListHeader.name")}</Row>
          </Col>
          <Col xs={3} className={"align-content-center"}>
            <Row>{t("projectListHeader.email")}</Row>
          </Col>
          <Col xs={2} className={"align-content-center"}>
            <Row>{t("projectListHeader.position")}</Row>
          </Col>
          <Col xs={4} className={"align-content-center"}>
            <Row className={"justify-content-center"}>{t("projectListHeader.assessment")}</Row>
          </Col>
        </Row>
      </Card>

      <ScrollableCard bottom={80} top={0}>
        <Card className={"list-container"} style={{ backgroundColor: isInModal ? "#f8f9fa" : "white" }}>
          {projectList &&
            projectList.map((project, i) => (
              <Card className={"list-row position-relative"} key={i}>
                {project.candidate.isNew && (
                  <div className={"text-10 text-color-gray-light"} style={{ top: 10, left: 10 }}>
                    {t("projectList.newTag")}
                  </div>
                )}
                <Row
                  className={
                    "justify-content-between ms-3 ms-lg-5 text-16 text-color-gray-dark fw-medium position-relative me-4"
                  }
                  style={{ minHeight: "30px" }}
                >
                  <Col xs={12} lg={3} className={"align-content-end"}>
                    <Row>{project.candidate.candidateName}</Row>
                  </Col>
                  <Col xs={12} lg={3} className={"align-content-end"}>
                    <Row>{project.candidate.email}</Row>
                  </Col>
                  <Col xs={12} lg={2} className={"text-color-gray-light align-content-end mt-2 mt-lg-0"}>
                    <Row>{project.position?.name}</Row>
                  </Col>
                  <Col xs={12} lg={4} className={"text-color-gray-light align-content-end mt-1 mt-lg-0"}>
                    <Row className={"justify-content-lg-center"}>
                      {project.credit.map((credit, i) => (
                        <Col key={i} xs={"auto"} className={"px-1"}>
                          {credit.assessment.name}
                          {i !== project.credit.length - 1 && ","}
                        </Col>
                      ))}
                    </Row>
                  </Col>

                  <div className="position-absolute top-50 translate-middle-y w-auto" style={{ right: -35 }}>
                    <div
                      className="hover-bg-darken align-content-center"
                      onClick={() => dispatch(RemoveFromProjectList({ candidateId: project.candidate.candidateId }))}
                    >
                      <IconSvg icon="cross" />
                    </div>
                  </div>
                </Row>
              </Card>
            ))}
        </Card>
      </ScrollableCard>
    </Card>
  );
};

export default ProjectList;
